import {createEntityMeta,SyncStatus} from '../offline/entity.js';
import {
  createLiveStageTransition,
  orderLiveStageTransitions
} from './stage-transition.js';

export const LIVE_STAGE_TRANSITION_ENTITY_TYPE='live_stage_transition';

function required(value,label){
  const text=String(value||'').trim();
  if(!text)throw new TypeError(label+' is required');
  return text;
}

export function createLiveStageTransitionStore({
  repository,
  queue,
  userId,
  now=()=>new Date().toISOString()
}={}){
  if(!repository?.get||!repository?.list||!repository?.put)throw new TypeError('repository with get/list/put is required');
  if(!queue?.enqueue)throw new TypeError('sync queue is required');
  const owner=required(userId,'userId');

  async function get(id){
    const row=await repository.get(LIVE_STAGE_TRANSITION_ENTITY_TYPE,required(id,'id'));
    if(!row)return null;
    if(row.userId!==owner)throw new Error('LIVE_STAGE_TRANSITION_OWNER_MISMATCH');
    return Object.freeze(row);
  }

  async function list(sessionId){
    const session=required(sessionId,'sessionId');
    const rows=await repository.list(LIVE_STAGE_TRANSITION_ENTITY_TYPE);
    const owned=(rows||[]).filter(row=>row.userId===owner&&row.sessionId===session);
    const ordered=orderLiveStageTransitions(owned);
    const byId=new Map(owned.map(row=>[row.id,row]));
    return Object.freeze(ordered.map(value=>Object.freeze({...byId.get(value.id),...value})));
  }

  async function append(sessionId,input={}){
    const session=required(sessionId,'sessionId');
    const value=createLiveStageTransition({
      ...input,
      userId:owner,
      sessionId:session,
      transitionedAt:input.transitionedAt||now()
    });
    const existing=await repository.get(LIVE_STAGE_TRANSITION_ENTITY_TYPE,value.id);
    if(existing)throw new Error('LIVE_STAGE_TRANSITION_ALREADY_EXISTS');
    const entity={
      ...createEntityMeta({id:value.id,now:now(),syncStatus:SyncStatus.PENDING_CREATE}),
      ...value
    };
    return queue.enqueue(LIVE_STAGE_TRANSITION_ENTITY_TYPE,entity,'create');
  }

  return Object.freeze({append,get,list});
}
